export default function splitCommaSeparatedList(list: string): string[] {
  return list
    .split(",")
    .map(item => item.trim())
    .filter(item => item.length > 0);
}
